import React from "react";
import {
    Layout,
    Card,
    Typography,
    Tooltip,
    Divider,
    Tag,
    Button,
    Row,
    Col,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Content } = Layout;
const { Title, Text } = Typography;

const VendorDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const data = location.state?.vendorData;

    if (!data) {
        return (
            <div style={{ padding: 40, textAlign: "center" }}>
                No discount data found
            </div>
        );
    }

    return (
        <div style={{ padding: 24, background: "#f5f7fb", minHeight: "100vh" }}>
            {/* 🔙 Back */}
            <Button
                icon={<LeftOutlined />}
                type="link"
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Back
            </Button>

            <Layout>
                <Content>
                    {/* 🔥 HEADER CARD */}
                    <Card
                        style={{
                            borderRadius: 16,
                            marginBottom: 20,
                            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                                <Title level={3} style={{ marginBottom: 8 }}>
                                    {data.name}
                                </Title>

                                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                                    <Tag color="blue">{data.type}</Tag>
                                    <Tag color="green">
                                        {data.type === "Percentage"
                                            ? `${data.value}% OFF`
                                            : `₹ ${data.value} OFF`}
                                    </Tag>
                                    <Tag
                                        color={data.status === "Active" ? "green" : "red"}
                                    >
                                        {data.status}
                                    </Tag>
                                </div>
                            </div>

                            <div>
                                <Tag color="purple" style={{ fontSize: 14 }}>
                                    Code: {data.code || "N/A"}
                                </Tag>
                            </div>
                        </div>
                    </Card>

                    {/* 🔥 COMBINED DETAILS CARD */}
                    <Card style={{ borderRadius: 16 }}>
                        {/* DESCRIPTION */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div>
                                <Title level={4}>Description</Title>

                                <Text type="secondary">
                                    {data.description || "No description available"}
                                </Text>

                            </div>
                            <Tooltip title='Item status'>
                                <div
                                >
                                    {data.fld_is_approval_rejection === "1" && (
                                        <Tag color="green"
                                            style={{
                                                fontSize: "14px",
                                                padding: "4px 12px",
                                                lineHeight: "24px",
                                                borderRadius: "6px",
                                            }}>Approved</Tag>
                                    )}

                                    {data.fld_is_approval_rejection === "2" && (
                                        <Tag color="red" style={{
                                            fontSize: "14px",
                                            padding: "4px 12px",
                                            lineHeight: "24px",
                                            borderRadius: "6px",
                                        }}>Rejected</Tag>
                                    )}

                                    {(data.fld_is_approval_rejection === "0" ||
                                        !data.fld_is_approval_rejection) && (
                                            <Tag color="orange" style={{
                                                fontSize: "14px",
                                                padding: "4px 12px",
                                                lineHeight: "24px",
                                                borderRadius: "6px",
                                            }}>Pending</Tag>
                                        )}
                                </div>
                            </Tooltip>
                        </div>


                        <Divider />

                        {/* DETAILS */}
                        <Title level={4}>Vendor Details</Title>

                        <Row gutter={[16, 16]}>
                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Discount Code</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.code || "N/A"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Discount Type</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.type}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Discount Value</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.type === "Percentage"
                                            ? `${data.value}%`
                                            : `₹ ${data.value}`}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Minimum Order Value</Text>
                                    <div style={{ marginTop: 6 }}>
                                        ₹ {data.minOrder || "0"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Maximum Discount</Text>
                                    <div style={{ marginTop: 6 }}>
                                        ₹ {data.maxDiscount || "0"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Total Usage Limit</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.usageLimit || "N/A"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Apply Discount On</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.applyOn || "All Products"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>User Eligibility</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.userEligibility || "All Users"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Per User Limit</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.perUserLimit || "N/A"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Status</Text>
                                    <div style={{ marginTop: 6 }}>
                                        <Tag color={data.status === "Active" ? "green" : "red"}>
                                            {data.status}
                                        </Tag>
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Start Date</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.startDate || "N/A"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>End Date</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.endDate || "N/A"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Created Date</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.createdDate || "Auto Generated"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Contact Email</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.email || "N/A"}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={12}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Contact Mobile</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.mobile || "N/A"}
                                    </div>
                                </Card>
                            </Col>
                        </Row>

                        <Divider />

                        {/* EXTRA SECTIONS */}
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>How to Redeem</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.howToRedeem?.split(", ").map((t, i) => (
                                            <div key={i}>• {t}</div>
                                        ))}
                                    </div>
                                </Card>
                            </Col>

                            <Col span={24}>
                                <Card style={{ borderRadius: 12 }}>
                                    <Text strong>Terms & Conditions</Text>
                                    <div style={{ marginTop: 6 }}>
                                        {data.terms || "Standard terms and conditions apply."}
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </Content>
            </Layout>
        </div>
    );
};

export default VendorDetails;